import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataTableValue } from 'primereact/datatable';

import { Table } from '@/components';
import { DocumentoSeleccionado } from '@/types/getPendingPaymentsType';

import { tableColumns } from './columns';
import { tableFilters } from './tableFilters';
import styles from './AccountStamentTable.module.scss';

type AccountStamentTableProps = {
  data?: DocumentoSeleccionado[];
  isLoading?: boolean;
  handleSelectionChange?: (e: { value: unknown }) => void;
  selectedItems?: unknown[];
  sumTotal?: number;
  extraColumn?: boolean;
};

const AccountStamentTable: FC<AccountStamentTableProps> = ({
  data,
  isLoading,
  handleSelectionChange,
  selectedItems,
  sumTotal,
  extraColumn = false,
}) => {
  const { t } = useTranslation('accountStatement');

  const total = useMemo(() => {
    const totalAmount = data?.reduce((acc, item) => {
      return acc + (item?.impMovMo || 0);
    }, 0);
    const totalFormated = totalAmount?.toLocaleString('es-UY', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return totalFormated;
  }, [data]);

  const sumSelectedFormat = useMemo(() => {
    const totalFormated = sumTotal?.toLocaleString('es-UY', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return totalFormated;
  }, [sumTotal]);

  const columns = useMemo(() => {
    const body = tableColumns(t);
    if (!extraColumn) return body;

    body.splice(body.length - 2, 0, {
      field: 'montoRetencion',
      header: t('withholding'),
      sortable: true,
      filter: true,
    });

    return body;
  }, [extraColumn, t]);

  return (
    <div className={styles.tableContainer}>
      <Table
        className={styles.customTable}
        columns={columns}
        data={data as DataTableValue[]}
        isLoading={isLoading}
        onSelectionChange={handleSelectionChange}
        selectedItems={selectedItems as DataTableValue[]}
        filterDisplay="menu"
        filters={tableFilters}
        footer={
          <div className="w-full flex flex-row justify-content-end">
            <div className="flex flex-column mx-3 align-items-end">
              <p className="text-primary lg:text-lg text-sm">
                {t('selectedTotalAmount')}
              </p>
              <p className="text-primary font-bold lg:text-2xl text-lg">
                USD {sumSelectedFormat}
              </p>
            </div>
            <div className="flex flex-column ml-3 align-items-end">
              <p className="text-primary lg:text-lg text-sm">
                {t('endingBalance')}
              </p>
              <p className="text-primary font-bold lg:text-2xl text-lg">
                USD {total}
              </p>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default AccountStamentTable;
